import Ajax from '../services/Ajax';

export default class Orders {
  async create(properties) {
    const { data } = await Ajax.post('orders', properties);
    return data;
  }
}
